import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import List from "./List";
import {OcListMapType, OcSearchParamType} from "../interface";
import {Dispatch, SetStateAction} from "react";

interface PropsType {
    oc: OcListMapType
    searchParam: OcSearchParamType
    setSearchParam: Dispatch<SetStateAction<OcSearchParamType>>
    selectedItem: number[]
    setSelectedItem: Dispatch<SetStateAction<number[]>>
}

export default function TabNav({oc, searchParam, setSearchParam, selectedItem, setSelectedItem}: PropsType) {

    const clickTab = (region: string | null) => {
        region && setSearchParam({...searchParam, region: region, pageNo: 1})
        setSelectedItem([])
    }

    const renderTab = (key: string) => {
        return <Tab eventKey={key}
                    title={key}
                    active={searchParam.region === key}>
            <List oc={oc}
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}/>
        </Tab>
    }

    return <div className="position-relative">
        <Tabs
            transition={false}
            className="mytab_pills mb-15px"
            variant="pills"
            activeKey={searchParam.region}
            defaultActiveKey="SEA"
            onSelect={(eventKey) => clickTab(eventKey)}
        >
            {renderTab("SEA")}
            {renderTab("IND")}
            {renderTab("ANZ")}
            {renderTab("CHN")}
        </Tabs>
    </div>
}